// Small shared presentational atoms for the simulation skin. People and label
// colors come from the SimulationContext (fetched config) rather than hardcoded
// imports, so any seeded simulation renders with its own cast + palette.
import { useSimulation, resolvePerson } from "./SimulationContext";

export function Avatar({ person, size = "" }) {
  const { peopleByKey } = useSimulation();
  const p = resolvePerson(person, peopleByKey);
  if (!p) return null;
  return (
    <span
      className={`mi-avatar ${size}`}
      style={{ background: p.color }}
      title={`${p.name}${p.role ? ` · ${p.role}` : ""}`}
    >
      {p.initials}
    </span>
  );
}

export function Label({ text }) {
  const { labelsByKey } = useSimulation();
  const c = labelsByKey[text] || { bg: "#dfe1e6", fg: "#42526e" };
  return (
    <span className="mi-label" style={{ background: c.bg, color: c.fg }}>
      {text}
    </span>
  );
}

const STATUS_CLASS = {
  "To Do": "todo",
  todo: "todo",
  "Not Started": "todo",
  "In Progress": "inprogress",
  in_progress: "inprogress",
  QA: "qa",
  qa: "qa",
  "In QA": "qa",
  Done: "done",
  done: "done",
  Completed: "done",
};

// Human labels for the derived board status keys.
const STATUS_LABEL = {
  todo: "To Do",
  in_progress: "In Progress",
  qa: "QA",
  done: "Done",
};

export function StatusPill({ status }) {
  const label = STATUS_LABEL[status] || status;
  return (
    <span className={`mi-status-pill ${STATUS_CLASS[status] || "todo"}`}>
      {label}
    </span>
  );
}

export function TypeIcon({ type }) {
  return (
    <span className={`mi-type ${type}`} title={type === "spike" ? "Spike" : "Task"}>
      {type === "spike" ? "◆" : "✓"}
    </span>
  );
}
